






































































































































import { Vue, Component } from 'vue-property-decorator'
import { formatarJSON } from '@/shareds/formatadores';
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue';
import { DataOptions } from 'vuetify';
import { Eventos, FiltroDeEventos } from '@/models/Eventos';
import { FindEventoUseCase } from '@/usecases/eventos/FindEventosUseCase';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { formatarDataHora } from '@/shareds/formatadores';
import moment from 'moment';
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue';
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue';
import { FindUsuarioUseCase } from '@/usecases';
import { UsuarioBase } from '@/models';
import RodapePersonalizado from '@/components/ui/data-tables/RodapePersonalizado.vue';

const FILTRO_DE_EVENTOS = 'FILTRO_DE_EVENTOS'

@Component({
	components: {
		RangeDatePicker,
		SeletorDeUsuario,
		DataTableDeCrud,
		RodapePersonalizado,
	},
})
export default class TelaDeEventos extends Vue {

	findEventoUseCase = new FindEventoUseCase()
	findUsuarioUseCase = new FindUsuarioUseCase()
	eventos: Eventos[] = []
	usuario: UsuarioBase | null = null
	carregando = false
	loading = false
	mostrar = false

	tipo = [
		'Marca','Estoque','Venda','Nota Fiscal','Produto',
		'Tag','Tabela de Preço','Turno de Venda','Plano',
		'Cliente','Fornecedor','Regra de Imposto','Consulta Nota',
		'Loja','Cupom','Usuario','Perfil','Categoria','Atributo',
		'Fechamento de Caixa','Motivo da Movimentação','Arquivo','Usuario Fechamento de Caixa',
	]


	requisicao = [
		'GET','POST','PUT','PATCH','DELETE',
	]

	headers = [
		{text: 'Log', value: 'comando', align: 'center'},
		{text: 'Usuário', value: 'nome', align: 'center'},
		{text: 'Data', value: 'dataHoraDeCriacao', align: 'center'},
		{text: 'Requisição', value: 'requisicao'},
		{text: 'Status', value: 'status'},
		{text: 'Tipo', value: 'tipo'},
	]

	filtro: FiltroDeEventos = localStorage[FILTRO_DE_EVENTOS]
		? JSON.parse(localStorage[FILTRO_DE_EVENTOS])
		: {
			datas: [],
			tipo: [],
			requisicao: [],
			nome: null,
		}

	totalRegistros = -1
	logSelecionado = {} as JSON

	get jsonFormatado() {
		return formatarJSON(this.logSelecionado)
	}


	get displayLog() {
		return this.eventos.map(itens =>( {
			...itens,
			dataHoraDeCriacao:	formatarDataHora(itens.dataHoraDeCriacao),
		}))
	}


	created() {
		this.busca()
	}

	atualizarPagina(page) {
		this.paginacao.page += page
		this.busca()
	}

	mostrarDetalhes(comando: JSON) {
		try {
			this.logSelecionado = comando;
			this.mostrar = true;
		} catch (error) {
			AlertModule.setError(error);
		}
	}

	limparFiltros() {

		this.usuario = null

		this.filtro = {
			datas: [],
			tipo: [],
			requisicao: [],
			nome: null,
		}
	}



	// @Watch('paginacao', { deep: true })
	// onChangePaginacao() {
	// 	this.busca()
	// }

	async corrigePaginacao() {
		this.paginacao.page = 0
		await this.busca()
	}

	async busca() {
		try {
			this.carregando = true

			if(this.usuario) {
				this.filtro.nome = this.usuario.nome
				
			}

			const params = {
				dataInicial:
					this.filtro.datas[0]
						? moment(this.filtro.datas[0]).toISOString()
						: undefined,
				dataFinal:
					this.filtro.datas[1]
						? moment(this.filtro.datas[1]).toISOString()
						: undefined,
				tipo: this.filtro.tipo || null,
				requisicao: this.filtro.requisicao || null,
				nome: this.filtro.nome,
				sort: 'dataHoraDeCriacao,desc',
				size: this.paginacao.itemsPerPage,
				page: this.paginacao.page,
			}

			const page = await this.findEventoUseCase.findAll({
				...params,
			})
		
			this.totalRegistros = page.totalElements
			this.eventos = page.content
			return page
			
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}

		
	}

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

}
